import { FC, useCallback, useContext, useMemo } from 'react';
import { Box, Select } from '@robocorp/components';
import { useTranslation } from 'react-i18next';
import { VariablesContext } from '../context';

import { useWorkerGroupLinkKeysQuery } from '~/queries';

export const SelectEnvironmentGroupLinkToken: FC = () => {
  const { endpoint, variables, setVariables } = useContext(VariablesContext);
  const { t } = useTranslation();

  const { data: workerGroupLinkKeys = [], isLoading: isLoadingWorkerGroupLinkKeys } =
    useWorkerGroupLinkKeysQuery(variables.environmentGroupId);

  const environmentGroupLinkKeysItems = useMemo(
    () =>
      Object.entries(workerGroupLinkKeys).map(([id, environmentGroupLinkKey]) => {
        return {
          label: environmentGroupLinkKey.name as string,
          value: id,
        };
      }),
    [workerGroupLinkKeys],
  );

  const onChange = useCallback(
    (linkTokenId: string) => {
      setVariables({
        linkTokenId,
      });
    },
    [setVariables],
  );

  let placeholder = environmentGroupLinkKeysItems.length
    ? `${t('choose')}...`
    : t('workerApi.noWorkerGroupLinkTokens');

  if (isLoadingWorkerGroupLinkKeys) {
    placeholder = t('loading');
  }

  return !endpoint.includes('linkTokenId') ? null : (
    <Box mb={20}>
      <Select
        label={t('workerApi.chooseWorkerGroupLinkToken')}
        items={environmentGroupLinkKeysItems}
        onChange={onChange}
        disabled={isLoadingWorkerGroupLinkKeys || environmentGroupLinkKeysItems.length < 1}
        value={variables.linkTokenId}
        placeholder={placeholder}
      />
    </Box>
  );
};
